import { render } from "./specialPooja.vue?vue&type=template&id=18595803"
import script from "./specialPooja.vue?vue&type=script&lang=js"
export * from "./specialPooja.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__